import { render, staticRenderFns } from "./HospitalProfile.vue?vue&type=template&id=3a0ad364&"
import script from "./HospitalProfile.vue?vue&type=script&lang=js&"
export * from "./HospitalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports